import React from "react";

import Box from "components/UI/Box";
import Button from "components/UI/Button";
import "./style.css";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Facility from "./Facility";
import Chain from "./Chain";
const OnboardingScreen = props => (
  <div
    style={{
      display: "flex",
      justifyContent: "center"
    }}
  >
    <Router>
      <Switch>
        <Route exact={true} path="/onboarding" component={OnboardingLanding} />
        <Route path="/onboarding/facility" component={Facility} />
        <Route path="/onboarding/chain" component={Chain} />
      </Switch>
    </Router>
  </div>
);

export default OnboardingScreen;

const OnboardingLanding = () => {
  return (
    <div className="div_Box_OnboardLanding">
      <Box outline>
        <div className="div_BoxContentWrapper_OnboardingLanding">
          <div>
            <p className="p_OnboardLandingTitle">Choose one of the option</p>
          </div>
          <div className="div_ActionButtonContainer_OnboardinLanding">
            <div className="div_Button_OnboardLanding_small">
              {/* <a href="chain">
                <Button type="primary">Chain</Button>
              </a> */}
              <Link to="/onboarding/chain">
                <Button type="primary">Chain</Button>
              </Link>
            </div>
            <div className="div_Button_OnboardLanding_small">
              <Link to="/onboarding/facility">
                <Button type="primary">Facility</Button>
              </Link>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};
